import { Keyboard, Platform, TouchableWithoutFeedback } from 'react-native';

import type { KeyboardDismissBoxProps } from './types';

export const KeyboardDismissBox = ({
  children,
  ...props
}: KeyboardDismissBoxProps) => {
  return (
    <TouchableWithoutFeedback
      {...props}
      onPress={() => {
        if (Platform.OS === 'web' || !Keyboard.isVisible()) {
          return;
        }

        Keyboard.dismiss();
      }}
    >
      {children}
    </TouchableWithoutFeedback>
  );
};
